import React, { useState, useMemo } from 'react';
import DateField from '../Shared/DateField';
import { FilterPill } from '../Shared/FilterPill';
import './Tracker.css';

/* ── Obiectele contestatiei ── */
const OBIECTE = {
  marca: {
    label: 'Marca',
    lege: 'Legea 84/1998',
    comisie: 'Comisia de contestatii marci',
    numarLabel: 'Nr. depozit',
    numarPlaceholder: 'M 2026 01234',
    denumireLabel: 'Denumirea marcii',
    termen: 'marca_zile',
    decizii: [
      ['respingere',       'Decizie de respingere la inregistrare',                  'contestatie_marca_decizie'],
      ['admitere_partiala','Decizie de admitere partiala',                           'contestatie_marca_decizie'],
      ['opozitie',         'Decizie a comisiei de examinare a opozitiilor',          'contestatie_marca_opozitie'],
      ['transmitere',      'Decizie privind transmiterea de drepturi',               'contestatie_marca_opozitie'],
      ['decadere',         'Decizie de decadere sau anulare',                        'contestatie_marca_opozitie'],
    ],
  },
  brevet: {
    label: 'Brevet de inventie',
    lege: 'Legea 64/1991',
    comisie: 'Comisia de reexaminare inventii',
    numarLabel: 'Nr. cerere',
    numarPlaceholder: 'a 2026 00123',
    denumireLabel: 'Titlul inventiei',
    termen: 'brevet_luni',
    decizii: [
      ['respingere', 'Hotarare de respingere a cererii',                 'contestatie_brevet'],
      ['acordare',   'Hotarare de acordare a brevetului',                'contestatie_brevet'],
      ['retrasa',    'Decizie prin care cererea e considerata retrasa',  'contestatie_brevet'],
      ['revocare',   'Cerere de revocare',                               'revocare_brevet'],
    ],
  },
  desen: {
    label: 'Desen sau model',
    lege: 'Legea 129/1992',
    comisie: 'Comisia de contestatii desene si modele',
    numarLabel: 'Nr. cerere',
    numarPlaceholder: 'f 2026 0123',
    denumireLabel: 'Produsul',
    termen: 'dmi_zile',
    decizii: [
      ['respingere',       'Hotarare de respingere',                              'contestatie_dmi'],
      ['admitere_partiala','Hotarare de admitere partiala',                       'contestatie_dmi'],
      ['opozitie',         'Hotarare pronuntata asupra unei opozitii',            'contestatie_dmi'],
    ],
  },
  model_utilitate: {
    label: 'Model de utilitate',
    lege: 'Legea 350/2007',
    comisie: 'Comisia de reexaminare',
    numarLabel: 'Nr. cerere',
    numarPlaceholder: 'u 2026 00045',
    denumireLabel: 'Titlul modelului',
    termen: 'brevet_luni',
    decizii: [
      ['respingere',   'Hotarare de respingere',    'contestatie_brevet'],
      ['inregistrare', 'Hotarare de inregistrare',  'contestatie_brevet'],
    ],
  },
};

/* ── Tarife (lei, O.G. 41/1998, anexele 1, 4 si 5 — cuantumuri 2026) ── */
const TAXE_DEFAULT = {
  contestatie_marca_decizie:   762,   // anexa 4, pct. 17 lit. a)
  contestatie_marca_opozitie: 1270,   // anexa 4, pct. 17 lit. b)
  contestatie_brevet:          762,   // anexa 1, pct. 20
  revocare_brevet:            1524,   // anexa 1, pct. 21
  contestatie_dmi:             762,   // anexa 5, pct. 11
};

const TERMENE_DEFAULT = {
  marca_zile:           30,   // de la comunicarea deciziei
  brevet_luni:           3,   // de la comunicarea hotararii
  dmi_zile:             30,   // de la comunicare
  instanta_zile:        30,   // actiune la Tribunalul Bucuresti
  cale_atac_zile:       15,   // apel la Curtea de Apel Bucuresti
  comunicare_hotarare:  15,   // termenul de comunicare hotarare motivata
};

const SOLUTII_COMISIE = [
  ['',              '— nesolutionata —'],
  ['admisa',        'Contestatie admisa'],
  ['admisa_partial','Contestatie admisa in parte'],
  ['respinsa',      'Contestatie respinsa'],
  ['retrasa',       'Contestatie retrasa'],
  ['anulata',       'Contestatie anulata ca netimbrata sau tardiva'],
];

const SOLUTII_INSTANTA = [
  ['',              '— pe rol —'],
  ['admisa',        'Actiune admisa'],
  ['admisa_partial','Actiune admisa in parte'],
  ['respinsa',      'Actiune respinsa'],
  ['perimata',      'Perimare / renuntare'],
];

/* ── Helpers ── */
const todayMid = () => { const d = new Date(); d.setHours(0,0,0,0); return d; };
const parseISO = (s) => (s ? new Date(s + 'T00:00:00') : null);
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const addMonths = (d, m) => { const x = new Date(d); x.setMonth(x.getMonth() + m); return x; };
const fmtRO = (d) => d ? d.toLocaleDateString('ro-RO', { day:'2-digit', month:'2-digit', year:'numeric' }) : '—';
const daysLeft = (d) => d ? Math.ceil((d - todayMid()) / 86400000) : null;
const fmtLei = (n) => Math.round(Number(n)).toLocaleString('ro-RO') + ' lei';

let _nextId = 0;
const newTermenId = () => `t_${Date.now()}_${_nextId++}`;

export function emptyRecord() {
  return {
    obiect: 'marca',
    pozitie: 'noi',              // noi = contestam decizia | terti = contestatie formulata impotriva noastra
    denumire: '',
    numarDosar: '',
    client: '',
    tipDecizie: 'respingere',
    numarDecizie: '',
    dataComunicare: '',
    depusa: false,
    dataDepunere: '',
    numarContestatie: '',
    taxaPlatita: false,
    taxaManuala: 0,              // 0 = se foloseste tariful din anexa
    motiveDepuse: false,
    dataSedinta: '',
    hotarareData: '',            // data pronuntarii
    hotarareComunicare: '',      // data comunicarii hotararii motivate
    solutieComisie: '',
    // faza judiciara
    instantaSesizata: false,
    dataActiune: '',
    numarDosarInstanta: '',
    termeneInstanta: [],         // [{ id, data, nota }]
    solutieFond: '',
    dataComunicareFond: '',
    caleAtac: false,
    dataCaleAtac: '',
    numarDosarApel: '',
    solutieFinala: '',
    observatii: '',
  };
}

/* ── Taxa aplicabila ── */
function calcTaxa(r, T) {
  if (Number(r.taxaManuala) > 0) return { suma: Number(r.taxaManuala), manuala: true };
  const cfg = OBIECTE[r.obiect];
  const dec = cfg.decizii.find(([k]) => k === r.tipDecizie) || cfg.decizii[0];
  return { suma: T[dec[2]] || 0, manuala: false, cheie: dec[2] };
}

/* ── Status ── */
function deriveStatus(r, TM) {
  const cfg = OBIECTE[r.obiect];
  const com = parseISO(r.dataComunicare);
  const dep = parseISO(r.dataDepunere);
  const sed = parseISO(r.dataSedinta);
  const hot = parseISO(r.hotarareData);
  const hotCom = parseISO(r.hotarareComunicare);
  const fondCom = parseISO(r.dataComunicareFond);

  const cheieTermen = cfg.termen;
  const termenContestatie = com
    ? (cheieTermen.endsWith('_luni') ? addMonths(com, TM[cheieTermen]) : addDays(com, TM[cheieTermen]))
    : null;
  const termenComunicareHotarare = hot ? addDays(hot, TM.comunicare_hotarare) : null;
  const termenInstanta = hotCom ? addDays(hotCom, TM.instanta_zile) : null;
  const termenCaleAtac = fondCom ? addDays(fondCom, TM.cale_atac_zile) : null;

  const termeneViitoare = (r.termeneInstanta || [])
    .map(t => ({ ...t, d: parseISO(t.data) }))
    .filter(t => t.d && t.d >= todayMid())
    .sort((a, b) => a.d - b.d);
  const urmatorulTermen = termeneViitoare[0] || null;

  const steps = [
    { key:'decizie',    label:'Decizie OSIM',           done: !!com,              date: com },
    { key:'contestatie',label:'Contestatie depusa',      done: r.depusa,           date: dep || termenContestatie },
    { key:'taxa',       label:'Taxa achitata',           done: r.taxaPlatita,      date: null },
    { key:'sedinta',    label:'Sedinta comisiei',        done: !!hot,              date: sed },
    { key:'hotarare',   label:'Hotararea comisiei',      done: !!hotCom,           date: hotCom || hot },
    { key:'instanta',   label:'Tribunalul Bucuresti',    done: !!r.solutieFond,    date: r.instantaSesizata ? parseISO(r.dataActiune) : termenInstanta },
    { key:'apel',       label:'Curtea de Apel',          done: !!r.solutieFinala,  date: r.caleAtac ? parseISO(r.dataCaleAtac) : termenCaleAtac },
  ];

  let alert;
  if (!com) {
    alert = { label:'De completat data comunicarii deciziei', sev:'neutral' };
  } else if (!r.depusa) {
    alert = { label:`Termen de contestatie — ${cfg.comisie}`, date: termenContestatie, sev:'act' };
  } else if (!r.taxaPlatita) {
    alert = { label:'Taxa de examinare a contestatiei nu e achitata', sev:'act' };
  } else if (!hot) {
    alert = sed && parseISO(r.dataSedinta) >= todayMid()
      ? { label:'Sedinta comisiei programata', date: sed, sev:'watch' }
      : { label:`In examinare la ${cfg.comisie.toLowerCase()}`, sev:'info' };
  } else if (!hotCom) {
    alert = { label:'Asteptare comunicare hotarare motivata', date: termenComunicareHotarare, sev:'info' };
  } else if (!r.instantaSesizata && termenInstanta && todayMid() <= termenInstanta) {
    alert = { label:'Termen pentru actiunea la Tribunalul Bucuresti', date: termenInstanta, sev:'act' };
  } else if (r.instantaSesizata && !r.solutieFond) {
    alert = urmatorulTermen
      ? { label:'Termen de judecata la Tribunalul Bucuresti', date: urmatorulTermen.d, sev:'watch' }
      : { label:'Pe rol la Tribunalul Bucuresti', sev:'info' };
  } else if (r.solutieFond && !r.caleAtac && termenCaleAtac && todayMid() <= termenCaleAtac) {
    alert = { label:'Termen pentru calea de atac', date: termenCaleAtac, sev:'act' };
  } else if (r.caleAtac && !r.solutieFinala) {
    alert = { label:'Pe rol la Curtea de Apel Bucuresti', sev:'info' };
  } else {
    alert = { label:'Dosar inchis', sev:'done' };
  }

  if (alert.date) {
    const dl = daysLeft(alert.date);
    alert.daysLeft = dl;
    if (dl < 0 && alert.sev === 'act') alert.sev = 'overdue';
  }

  return { cfg, steps, alert, com, dep, hot, hotCom, termenContestatie, termenComunicareHotarare, termenInstanta, termenCaleAtac, urmatorulTermen };
}

/* ════════════════════════ Component ════════════════════════ */
export default function ContestatieOSIMTracker({ data, onChange }) {
  const [r, setR] = useState(data);
  const [taxe, setTaxe] = useState(TAXE_DEFAULT);
  const [termene, setTermene] = useState(TERMENE_DEFAULT);
  const [showSetari, setShowSetari] = useState(false);

  const set = (patch) => {
    const next = { ...r, ...patch };
    setR(next);
    onChange(next);
  };

  const status = useMemo(() => deriveStatus(r, termene), [r, termene]);
  const taxaCalc = useMemo(() => calcTaxa(r, taxe), [r, taxe]);
  const cfg = status.cfg;

  const schimbaObiect = (v) => {
    const nou = OBIECTE[v];
    set({ obiect: v, tipDecizie: nou.decizii[0][0] });
  };

  const addTermen = () => set({ termeneInstanta: [...(r.termeneInstanta || []), { id: newTermenId(), data:'', nota:'' }] });
  const setTermen = (id, patch) => set({ termeneInstanta: r.termeneInstanta.map(t => t.id === id ? { ...t, ...patch } : t) });
  const delTermen = (id) => set({ termeneInstanta: r.termeneInstanta.filter(t => t.id !== id) });

  return (
    <div className="tracker">
      <AlertBanner status={status} />
      <Timeline steps={status.steps} />

      {/* Dosarul contestat */}
      <TrackerCard title="Dosarul contestat" badge={cfg.lege}>
        <div className="field">
          <label>Obiectul protectiei</label>
          <FilterPill value={r.obiect} onChange={e => schimbaObiect(e.target.value)}>
            {Object.entries(OBIECTE).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </FilterPill>
        </div>
        <div className="field">
          <label>Pozitia in procedura</label>
          <SegControl value={r.pozitie} onChange={v => set({ pozitie: v })}
            options={[['noi','Contestam noi'],['terti','Contestatie a unui tert']]} />
        </div>
        <div className="f-row">
          <div className="field">
            <label>{cfg.denumireLabel}</label>
            <input type="text" value={r.denumire} onChange={e => set({ denumire: e.target.value })} />
          </div>
          <div className="field">
            <label>{cfg.numarLabel}</label>
            <input type="text" value={r.numarDosar} onChange={e => set({ numarDosar: e.target.value })} placeholder={cfg.numarPlaceholder} className="mono" />
          </div>
        </div>
        <div className="field">
          <label>Client</label>
          <input type="text" value={r.client} onChange={e => set({ client: e.target.value })} />
        </div>
        <div className="field">
          <label>Actul contestat</label>
          <FilterPill value={r.tipDecizie} onChange={e => set({ tipDecizie: e.target.value })}>
            {cfg.decizii.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </FilterPill>
        </div>
        <div className="f-row">
          <div className="field">
            <label>Nr. decizie / hotarare</label>
            <input type="text" value={r.numarDecizie} onChange={e => set({ numarDecizie: e.target.value })} className="mono" />
          </div>
          <div className="field">
            <label>Data comunicarii</label>
            <DateField value={r.dataComunicare} onChange={v => set({ dataComunicare: v })} />
            <span className="f-hint">De aici curge termenul de contestatie.</span>
          </div>
        </div>
        {status.termenContestatie && (
          <DeadlineChip label={`Termen de contestatie (${cfg.termen.endsWith('_luni') ? `${termene[cfg.termen]} luni` : `${termene[cfg.termen]} zile`})`}
            date={status.termenContestatie} act={!r.depusa} />
        )}
      </TrackerCard>

      {/* Contestatia */}
      <TrackerCard title={`Contestatia — ${cfg.comisie}`}>
        <label className="check-label">
          <input type="checkbox" checked={r.depusa} onChange={e => set({ depusa: e.target.checked })} />
          Contestatia a fost depusa
        </label>
        {r.depusa && (
          <div className="dep-section">
            <div className="f-row">
              <div className="field">
                <label>Nr. contestatie</label>
                <input type="text" value={r.numarContestatie} onChange={e => set({ numarContestatie: e.target.value })} className="mono" />
              </div>
              <div className="field">
                <label>Data depunerii</label>
                <DateField value={r.dataDepunere} onChange={v => set({ dataDepunere: v })} />
              </div>
            </div>
            <label className="check-label">
              <input type="checkbox" checked={r.taxaPlatita} onChange={e => set({ taxaPlatita: e.target.checked })} />
              Taxa a fost achitata
            </label>
            <label className="check-label">
              <input type="checkbox" checked={r.motiveDepuse} onChange={e => set({ motiveDepuse: e.target.checked })} />
              Motivele au fost depuse integral
            </label>

            <div className="tr-divider mt8">Solutionare</div>
            <div className="f-row">
              <div className="field">
                <label>Data sedintei</label>
                <DateField value={r.dataSedinta} onChange={v => set({ dataSedinta: v })} />
              </div>
              <div className="field">
                <label>Data pronuntarii</label>
                <DateField value={r.hotarareData} onChange={v => set({ hotarareData: v })} />
              </div>
              <div className="field">
                <label>Data comunicarii hotararii</label>
                <DateField value={r.hotarareComunicare} onChange={v => set({ hotarareComunicare: v })} />
                <span className="f-hint">Porneste termenul pentru instanta.</span>
              </div>
            </div>
            <div className="field">
              <label>Solutia comisiei</label>
              <FilterPill value={r.solutieComisie} onChange={e => set({ solutieComisie: e.target.value })}>
                {SOLUTII_COMISIE.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </FilterPill>
            </div>
            {status.termenComunicareHotarare && !r.hotarareComunicare && (
              <DeadlineChip label={`Comunicare hotarare motivata (${termene.comunicare_hotarare} zile)`} date={status.termenComunicareHotarare} />
            )}
          </div>
        )}
      </TrackerCard>

      {/* Faza judiciara */}
      <TrackerCard title="Faza judiciara — Tribunalul Bucuresti">
        {status.termenInstanta && !r.instantaSesizata && (
          <DeadlineChip label={`Termen actiune Tribunalul Bucuresti (${termene.instanta_zile} zile)`} date={status.termenInstanta} act />
        )}
        <label className="check-label mt8">
          <input type="checkbox" checked={r.instantaSesizata} onChange={e => set({ instantaSesizata: e.target.checked })} />
          Hotararea comisiei a fost atacata in instanta
        </label>
        {r.instantaSesizata && (
          <div className="dep-section">
            <div className="f-row">
              <div className="field">
                <label>Data introducerii actiunii</label>
                <DateField value={r.dataActiune} onChange={v => set({ dataActiune: v })} />
              </div>
              <div className="field">
                <label>Nr. dosar Tribunalul Bucuresti</label>
                <input type="text" value={r.numarDosarInstanta} onChange={e => set({ numarDosarInstanta: e.target.value })} placeholder="12345/3/2026" className="mono" />
              </div>
            </div>

            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 6 }}>
              <span style={{ fontSize: 12, fontWeight: 600 }}>Termene de judecata</span>
              <button type="button" className="btn-link" onClick={addTermen}>+ Adauga termen</button>
            </div>
            {(r.termeneInstanta || []).length === 0 ? (
              <p className="f-hint">Niciun termen inregistrat.</p>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap: 4 }}>
                {r.termeneInstanta.map(t => {
                  const d = parseISO(t.data);
                  const trecut = d && d < todayMid();
                  return (
                    <div key={t.id} style={{ display:'flex', alignItems:'center', gap: 8, padding:'6px 8px', border:`1px solid var(--border)`, borderRadius: 6, background: trecut ? 'var(--bg-subtle)' : 'transparent' }}>
                      <DateField value={t.data} onChange={v => setTermen(t.id, { data: v })} style={{ width: 130 }} />
                      <input type="text" value={t.nota} onChange={e => setTermen(t.id, { nota: e.target.value })}
                        placeholder="Ce s-a dispus la termen…" style={{ flex:1, fontSize: 12, border:'none', outline:'none', background:'transparent' }} />
                      <button type="button" className="btn-link" style={{ color:'var(--danger)' }} onClick={() => delTermen(t.id)}>✕</button>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="f-row mt8">
              <div className="field">
                <label>Solutia in prima instanta</label>
                <FilterPill value={r.solutieFond} onChange={e => set({ solutieFond: e.target.value })}>
                  {SOLUTII_INSTANTA.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </FilterPill>
              </div>
              <div className="field">
                <label>Data comunicarii hotararii</label>
                <DateField value={r.dataComunicareFond} onChange={v => set({ dataComunicareFond: v })} />
                <span className="f-hint">Porneste termenul de cale de atac.</span>
              </div>
            </div>

            {status.termenCaleAtac && !r.caleAtac && (
              <DeadlineChip label={`Termen cale de atac (${termene.cale_atac_zile} zile)`} date={status.termenCaleAtac} act />
            )}
            <label className="check-label mt8">
              <input type="checkbox" checked={r.caleAtac} onChange={e => set({ caleAtac: e.target.checked })} />
              S-a exercitat calea de atac la Curtea de Apel Bucuresti
            </label>
            {r.caleAtac && (
              <div className="f-row dep-section">
                <div className="field">
                  <label>Data declararii</label>
                  <DateField value={r.dataCaleAtac} onChange={v => set({ dataCaleAtac: v })} />
                </div>
                <div className="field">
                  <label>Nr. dosar apel</label>
                  <input type="text" value={r.numarDosarApel} onChange={e => set({ numarDosarApel: e.target.value })} className="mono" />
                </div>
                <div className="field">
                  <label>Solutia definitiva</label>
                  <FilterPill value={r.solutieFinala} onChange={e => set({ solutieFinala: e.target.value })}>
                    {SOLUTII_INSTANTA.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </FilterPill>
                </div>
              </div>
            )}
          </div>
        )}
      </TrackerCard>

      {/* Taxa */}
      <TrackerCard title="Taxa de examinare" badge="tarife 01.01.2026">
        <table className="fee-table">
          <tbody>
            <FeeRow label={`${(cfg.decizii.find(([k]) => k === r.tipDecizie) || cfg.decizii[0])[1]} — ${cfg.label.toLowerCase()}`} value={taxaCalc.suma} />
          </tbody>
          <tfoot>
            <tr className="fee-total">
              <td>Taxa datorata</td>
              <td>{fmtLei(taxaCalc.suma)}</td>
            </tr>
          </tfoot>
        </table>
        <div className="field mt8">
          <label>Taxa stabilita manual (0 = tarif din anexa)</label>
          <input type="number" min="0" value={r.taxaManuala}
            onChange={e => set({ taxaManuala: Math.max(0, Number(e.target.value)||0) })} className="mono" />
          <span className="f-hint">Taxele judiciare pentru faza din instanta nu sunt incluse — se stabilesc potrivit O.U.G. 80/2013.</span>
        </div>

        <button type="button" className="btn-link mt8" onClick={() => setShowSetari(s => !s)}>
          {showSetari ? '▾' : '▸'} Tarife si termene (editabile)
        </button>
        {showSetari && (
          <div className="tarife-editor">
            <div className="tr-divider">Tarife (lei)</div>
            {[['contestatie_marca_decizie','Marci — decizie'],['contestatie_marca_opozitie','Marci — comisie opozitii'],
              ['contestatie_brevet','Inventii'],['revocare_brevet','Revocare brevet'],['contestatie_dmi','Desene si modele']
            ].map(([k, l]) => (
              <label key={k} className="tarife-field">{l}
                <input type="number" value={taxe[k]} onChange={e => setTaxe({ ...taxe, [k]: Number(e.target.value)||0 })} />
              </label>
            ))}
            <div className="tr-divider">Termene</div>
            {[['marca_zile','Contestatie marci (zile)'],['brevet_luni','Contestatie inventii (luni)'],
              ['dmi_zile','Contestatie desene (zile)'],['comunicare_hotarare','Comunicare hotarare (zile)'],
              ['instanta_zile','Actiune in instanta (zile)'],['cale_atac_zile','Cale de atac (zile)']
            ].map(([k, l]) => (
              <label key={k} className="tarife-field">{l}
                <input type="number" value={termene[k]} onChange={e => setTermene({ ...termene, [k]: Number(e.target.value)||0 })} />
              </label>
            ))}
          </div>
        )}
      </TrackerCard>

      <TrackerCard title="Observatii interne">
        <textarea className="tr-textarea" value={r.observatii} onChange={e => set({ observatii: e.target.value })}
          rows={3} placeholder="Motivele contestatiei, argumentele OSIM, strategia in instanta…" />
      </TrackerCard>
    </div>
  );
}

/* ── Sub-components ── */
function AlertBanner({ status }) {
  const { alert } = status;
  return (
    <div className={`tr-alert sev-${alert.sev}`}>
      <strong>{alert.label}</strong>
      {alert.date && (
        <span className="tr-alert-date">
          Termen: {fmtRO(alert.date)}
          {typeof alert.daysLeft === 'number' && (
            alert.daysLeft < 0 ? ` · depasit cu ${Math.abs(alert.daysLeft)} zile` : ` · ${alert.daysLeft} zile ramase`
          )}
        </span>
      )}
    </div>
  );
}

function Timeline({ steps }) {
  const activeIdx = steps.findIndex(s => !s.done);
  return (
    <div className="tr-timeline">
      {steps.map((s, i) => {
        const isActive = i === activeIdx;
        const done = s.done;
        return (
          <React.Fragment key={s.key}>
            {i > 0 && <span className={`tl-line${done || steps[i-1].done ? ' tl-line-done' : ''}`} />}
            <div className="tl-step">
              <span className={`tl-dot${done ? ' done' : isActive ? ' active' : ''}`}>{done ? '✓' : i+1}</span>
              <span className={`tl-label${isActive ? ' active' : done ? ' done' : ''}`}>{s.label}</span>
              {s.date && <span className="tl-date">{fmtRO(s.date)}</span>}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

function TrackerCard({ title, badge, children }) {
  return (
    <div className="tr-card">
      <div className="tr-card-head">
        <span className="tr-card-title">{title}</span>
        {badge && <span className="tr-badge">{badge}</span>}
      </div>
      <div className="tr-card-body">{children}</div>
    </div>
  );
}

function SegControl({ value, onChange, options }) {
  return (
    <div className="seg-ctrl">
      {options.map(([v, label]) => (
        <button key={v} type="button" className={`seg-btn${value === v ? ' seg-active' : ''}`}
          onClick={() => onChange(v)}>{label}</button>
      ))}
    </div>
  );
}

function FeeRow({ label, value }) {
  return (
    <tr>
      <td>{label}</td>
      <td className="fee-val">{fmtLei(value)}</td>
    </tr>
  );
}

function DeadlineChip({ label, date, act }) {
  if (!date) return null;
  const dl = daysLeft(date);
  const overdue = dl < 0;
  const soon = dl >= 0 && dl <= 14;
  const cls = overdue ? 'chip-overdue' : (act && soon) ? 'chip-act' : 'chip-neutral';
  return (
    <div className={`deadline-chip ${cls}`}>
      <span>{label}</span>
      <span>{fmtRO(date)} · {overdue ? `${Math.abs(dl)}z depasit` : `${dl}z`}</span>
    </div>
  );
}
